import SetMy2NAppAccessMenuItem from './SetMy2NAppAccessMenuItem';

export default SetMy2NAppAccessMenuItem;
